var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsBatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "carbon:batch-job",
    clipPath: "url(#clip0_859_4085)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.3981 22.7759V21.0993H25.6369C25.5288 20.5745 25.3204 20.0756 25.0233 19.6298L26.2723 18.3807L25.087 17.1954L23.8379 18.4444C23.3922 18.1472 22.8932 17.9389 22.3684 17.8308V16.0696H20.6919V17.8308C20.1671 17.9389 19.6681 18.1473 19.2223 18.4444L17.9733 17.1954L16.788 18.3807L18.037 19.6298C17.7398 20.0756 17.5314 20.5745 17.4234 21.0993H15.6621V22.7759H17.4234C17.5315 23.3006 17.7399 23.7996 18.037 24.2454L16.788 25.4944L17.9733 26.6798L19.2223 25.4307C19.6681 25.728 20.1671 25.9363 20.6919 26.0444V27.8056H22.3684V26.0444C22.8932 25.9362 23.3921 25.7279 23.8379 25.4307L25.087 26.6798L26.2723 25.4944L25.0233 24.2454C25.3205 23.7996 25.5289 23.3006 25.6369 22.7759H27.3981ZM21.5301 24.4524C20.1436 24.4524 19.0153 23.3241 19.0153 21.9376C19.0153 20.5511 20.1436 19.4227 21.5301 19.4227C22.9167 19.4227 24.045 20.5511 24.045 21.9376C24.045 23.3241 22.9167 24.4524 21.5301 24.4524ZM17.3387 15.2313H10.6324C10.1878 15.2313 9.76132 15.0547 9.4469 14.7402C9.13248 14.4258 8.95584 13.9994 8.95584 13.5547V4.33357C8.95584 3.88891 9.13248 3.46247 9.4469 3.14805C9.76132 2.83363 10.1878 2.65699 10.6324 2.65699H17.3387C17.7834 2.65699 18.2098 2.83363 18.5242 3.14805C18.8386 3.46247 19.0153 3.88891 19.0153 4.33357V13.5547C19.0153 13.9994 18.8386 14.4258 18.5242 14.7402C18.2098 15.0547 17.7834 15.2313 17.3387 15.2313ZM10.6324 13.5547H17.3387V4.33357H10.6324V13.5547Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.8238 18.5844H7.27927C6.83461 18.5844 6.40817 18.4078 6.09375 18.0934C5.77933 17.779 5.60269 17.3525 5.60269 16.9079V6.84843H7.27927V16.9079H14.8238V18.5844Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.4707 21.9376H3.92612C3.00149 21.9376 2.24954 21.1856 2.24954 20.261V10.2016H3.92612V20.261H11.4707V21.9376Z",
    fill: "#3A3A3A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_859_4085"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.8252,
    height: 26.8252,
    fill: "white",
    transform: "translate(0.572968 0.980419)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsBatch);
export default __webpack_public_path__ + "static/media/settings-batch.effa5a33d1b98b63f18826e19da9bc1a.svg";
export { ForwardRef as ReactComponent };